import { createApi } from '@reduxjs/toolkit/query/react';

import {
  LeaderboardFilters,
  Leaderboard,
  MyUserFilters,
  MyUser,
} from '@app/store/slices/friends/friendsTypes';
import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';
import { ApiResponse } from '@app/store/utils/common';

export const friendsApi = createApi({
  reducerPath: 'friendsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getLeaderboard: builder.query<ApiResponse<Leaderboard>, LeaderboardFilters>({
      query: (params) => ({
        url: '/friends/leaderboard',
        params,
      }),
    }),
    getMyUser: builder.query<ApiResponse<MyUser>, MyUserFilters>({
      query: (params) => ({
        url: '/friends/me',
        params,
      }),
    }),
  }),
});

export const { useGetLeaderboardQuery, useGetMyUserQuery } = friendsApi;
